import ClickOutside from 'vue-click-outside'

const ClickOutsideDirective = ClickOutside?.directive ?? ClickOutside

export default ClickOutsideDirective
